/**
 * Languages of an ad set in the wizard: `audienceTargeting.settings[stage][audience].locales`, a list of
 * `{ key, name }` with Meta's locale id. Absent means the ad set has no language setting.
 */

export const getAudienceLocales = (audienceTargetingData, stageId, audienceId) => {
    const value = audienceTargetingData?.settings?.[stageId]?.[audienceId]?.locales
    return Array.isArray(value) ? value : null
}

/**
 * Languages to submit, or undefined to send none. An empty list is only sent with `keepEmpty`, which
 * an edit uses to clear languages the ad set already had; otherwise an empty list means no setting.
 */
export const localesForSubmission = (locales, { keepEmpty = false } = {}) => {
    if (!Array.isArray(locales)) return undefined
    if (locales.length === 0 && !keepEmpty) return undefined
    return locales.map(({ key, name }) => ({ key, name }))
}
